import { Box, Divider, IconButton, Stack, Typography } from '@mui/joy';
import React, { ReactElement, ReactNode, forwardRef } from 'react';
import { GoArrowLeft } from 'react-icons/go';

interface Props {
  children: ReactNode;
  title: ReactNode;
  actions?: ReactElement[];
  onBack?: () => void;
  disableDivider?: boolean;
}

const ContentsContainer = forwardRef<HTMLDivElement, Props>(
  ({ title, actions = [], onBack, disableDivider, children }, ref) => {
    return (
      <Stack sx={{ height: '100%', width: '100%', pb: '16px', position: 'relative' }} ref={ref}>
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
          sx={{ p: '16px', pb: '20px', minHeight: 84 }}>
          <Stack direction={'row'} gap={'12px'} alignItems={'center'}>
            {onBack && (
              <IconButton onClick={onBack}>
                <GoArrowLeft fontSize={24} color="#333" />
              </IconButton>
            )}
            {typeof title === 'string' && <Typography level="h3">{title}</Typography>}
            {typeof title !== 'string' && title}
          </Stack>
          <Stack direction={'row'} gap={'16px'} alignItems={'center'}>
            {React.Children.map(actions, (child, index) => React.cloneElement(child, { key: index }))}
          </Stack>
        </Stack>
        {!disableDivider && <Divider sx={{ mb: '20px' }} />}
        <Box flexGrow={1} sx={{ overflow: 'auto' }}>
          {children}
        </Box>
      </Stack>
    );
  }
);

export default ContentsContainer;
